/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: 'dark',
    themes: {
      light: {
        colors: {
          // Fondo general más gris para que las secciones (surface blanco) se enmarquen.
          background: '#E4E8EF',
          surface: '#FFFFFF',
          'surface-variant': '#EEF1F6',
        },
      },
    },
  },
})
